__turbopack_context__.v({
  "alternative": "heading-module-scss-module__NxZUoG__alternative",
  "compact": "heading-module-scss-module__NxZUoG__compact",
  "h2": "heading-module-scss-module__NxZUoG__h2",
  "h3": "heading-module-scss-module__NxZUoG__h3",
  "heading": "heading-module-scss-module__NxZUoG__heading",
  "regular": "heading-module-scss-module__NxZUoG__regular",
  "sub": "heading-module-scss-module__NxZUoG__sub",
});
